/***
*
*   NOTIFICATION
*   Banner notification that appears at the top of the screen.
*   Create a notification anytime using context.notification.show()
*   and pass the props below
*
*   PROPS
*   message: string containing the message
*   type - success/error/warning
*   autoclose - if false, the notification won't disapear until clicking the X
*
**********/

import React, { useContext, useRef } from 'react';
import { ViewContext, Button, Icon } from 'components/lib';
import { CSSTransition } from 'react-transition-group';
import './notification.scss';

export function Notification(props){

  const context = useContext(ViewContext);
  const data = props.data || context.notification.data;
  let _class = 'notification';
  if (props.format) _class += ` ${props.format}`;
  const nodeRef = useRef(null);
  
  return(
    <CSSTransition in appear timeout={ 0 } classNames={ _class } nodeRef={nodeRef}>
      <div ref={nodeRef} className={`notification ${props.type} ${props.format || ''} ${data.icon ? 'with-icon' : ''} ${props.inline ? '' : 'overlay'}`}>

        { data.icon && 
          <Icon 
            size={ 19 }
            color='dark' 
            image={ data.icon } 
         />
        }
        
        <p>{ data.text } <a href={data.url} target='_new'>{data.urlText}</a> </p>
        
        { !data.autoclose && !data.noclose &&

          <Button
            className='btn-close-notification'
            icon='x'
            color={ props.format === 'toast' ? 'dark' : 'light' }
            action={ context.notification.hide }
          />
        }

      </div>
    </CSSTransition>
  );
}
